import React from 'react';
import cn from 'classnames';
import InputMask from 'react-input-mask';

import Input from '../';
import classes from './inputPhone.module.scss';
import { IInputPhone, IInputPhoneProps } from './types';

const InputPhone: React.FC<IInputPhone> = ({
	className,
	value,
	onChange,
	onBlur,
	placeholder,
	mask = '+7 (999) 999 9999',
	error,
}) => {
	const handleChange = (inputValue: string): void => {
		const newValue = inputValue.replace(/[^+\d]+/g, '');
		onChange(newValue);
	};

	const renderInput = (props: IInputPhoneProps) => (
		<InputMask {...props} mask={mask} />
	);

	return (
		<Input
			className={cn(classes.inputPhone, className)}
			value={value}
			onChange={handleChange}
			onBlur={onBlur}
			placeholder={placeholder}
			error={error}
			renderInput={renderInput}
		/>
	);
};

export default InputPhone;
